import { atom } from 'jotai'

const notificationFeedAtom = atom<string | undefined>(undefined)

export const rwNotificationFeedAtom = atom(
  (get) => get(notificationFeedAtom),
  (_get, set, address: string | undefined) => {
    set(notificationFeedAtom, address)
  }
)

const mobileSearchAtom = atom<boolean>(false)

export const rwMobileSearchAtom = atom(
  (get) => get(mobileSearchAtom),
  (_get, set, open: boolean) => {
    set(mobileSearchAtom, open)
  }
)
